document.addEventListener("DOMContentLoaded", function() {
    console.log('script running');

    // script for alternative color
    const elements = document.querySelectorAll('.alternative-color p');

    elements.forEach(function(element) {
    const strongTags = document.querySelectorAll('.alternative-color strong');

    // Loop through each <strong> tag and change its color
    strongTags.forEach(function(strongTag) {
        strongTag.style.color = '#1570EF';
    });
    });



  // fade in animation using obeserver
  const fadeElements = document.querySelectorAll('.fade-in');

  // Create an Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {
    threshold: 0.3 // Trigger when 30% of the element is visible
  });

  fadeElements.forEach(element => {
    observer.observe(element);
  });



  //sticky header fix
const header = document.querySelector('.section-header');
  if (!header) {
    console.error('Header element not found!');
    return;
  }

  const scrollThresholdPercentage = 1;

  window.addEventListener('scroll', () => {
    // console.log('scrolling');
    const scrollPosition = window.scrollY; // Current scroll position
    const pageHeight = document.documentElement.scrollHeight - window.innerHeight; // Total scrollable height
    const scrollThreshold = (pageHeight * scrollThresholdPercentage) / 100; // Calculate threshold

    if (scrollPosition > scrollThreshold) {
      header.classList.add('fixed-header');
    } else {
      header.classList.remove('fixed-header');
    }
  });
  });


// first accordian opn
document.addEventListener("DOMContentLoaded", function () {
    let firstAccordion = document.querySelector(".accordion details");
    if (firstAccordion && !firstAccordion.hasAttribute("open")) {
        firstAccordion.setAttribute("open", "true");
    }
});
